define(function (require) {

  const partialDropdownOption = require('rhythm-fe-ui-components/src/uiPartials/droppy/uiDroppyOption.hbs');
  const FilterCode_Autocomplete_Model = require('civicsModels/core/autocomplete_filtercode_model');
  const DataModelStore = require('civicsBase/data_model_store');
  const IpsCollection = require('civicsBase/ipsModelCollection');

  const Utils = require('civicsUtils/general_utilities');
  const ViewManager = require('civicsUtils/view_manager');
  const FILTER_PROPERTY_TYPE = 'property';
  const FILTER_FORMULA_TYPE = 'formula';

  //A module that contains functions related to setting up a generic filter code field.
  const GenericFilterCodes = function () {

    this.previousData = '';
    this.portletId;
    this.conditionModel;
    this.conditionModelPropBind;
    this.targetFieldId;
    this.filterMoniker;
    this.prevDropdownSelectionValue;
    this.filterState = 'waiting';

    const _render = (settings) => {
      if (!settings)
        return;

      setPluginProperties(settings);
      let filterCodePromise = loadFilterCodes(settings.$targetField);
      $.when(filterCodePromise).done(($input) => {
        _setPostRenderEvent($input);
      });

    }

    const setPluginProperties = (settings) => {
      let arrFilterId = settings.filterId.split('-');
      this.portletId = arrFilterId[0];
      this.conditionFilterType = settings.conditionFilterType || FILTER_PROPERTY_TYPE;
      this.conditionModel = arrFilterId[1];
      this.targetFieldId = settings.targetFieldId;
      this.filterMoniker = settings.filterMoniker;

      if (this.conditionFilterType.toLowerCase() === FILTER_PROPERTY_TYPE)
        this.conditionModelPropBind = arrFilterId[2] ? arrFilterId[2] : settings.conditionField.substring(settings.conditionField.indexOf('.') + 1);

    }

    const loadFilterCodes = ($input) => {
      //return a promise.



      if (this.filterState === 'processing')
        return;

	    $input.trigger("setLoading");
      this.filterState = 'processing';

      let retPromise = $.Deferred();

      let filterCodePromise = filterCodesTypeTable[this.conditionFilterType.toLowerCase()]();
      let currentData = (this.conditionFilterType.toLowerCase() === FILTER_PROPERTY_TYPE) ? DataModelStore.getPropertyValue(this.portletId, this.conditionModel, this.conditionModelPropBind) : '';
      $.when(filterCodePromise).done((filterCodesData) => {
        _setupInputField($input, filterCodesData, currentData);
        retPromise.resolve($input);
      }).fail((response) => {
        ViewManager.errorToWindow(response);
        retPromise.reject()
      }).always(() => {
        $input.trigger("removeLoading");
        this.filterState = 'waiting';
      });

      return retPromise;
    }

    let filterCodesTypeTable = {
      property: () => {
        let fetchProm = $.Deferred();

        let currentData = DataModelStore.getPropertyValue(this.portletId, this.conditionModel, this.conditionModelPropBind);
        if (this.previousData === currentData) {
          fetchProm.resolve();
          return fetchProm;
        }

        let filterCodeModel = new FilterCode_Autocomplete_Model();
        filterCodeModel.portletId = this.portletId;
        filterCodeModel.conditionModel = this.conditionModel;
        filterCodeModel.conditionModelPropBind = this.conditionModelPropBind;
        filterCodeModel.filterMoniker = this.filterMoniker;
        filterCodeModel.conditionModelPropBindValue = currentData;
        filterCodeModel.targetFieldId = this.targetFieldId;
        filterCodeModel.type = FILTER_PROPERTY_TYPE;
        filterCodeModel.fetch({
          success: (response) => {
            fetchProm.resolve(response.get('documents'));
          },
          error: (response) => {
            fetchProm.reject(response);
          }
        })

        return fetchProm;
      },
      formula: () => {
        let retPromise = $.Deferred();

        let filterCodeModel = new FilterCode_Autocomplete_Model();
        filterCodeModel.portletId = this.portletId;
        filterCodeModel.conditionModel = this.conditionModel;
        filterCodeModel.filterMoniker = this.filterMoniker;
        filterCodeModel.targetFieldId = this.targetFieldId;
        filterCodeModel.type = FILTER_FORMULA_TYPE;
        let modelToSend = DataModelStore.get(this.portletId, this.conditionModel);
        let modelURL = modelToSend && modelToSend.url === 'function' ? modelURL = modelToSend.url() : '';
        let httpMethod = DataModelStore.getPropertyValue(this.portletId, this.conditionModel, "id") ? "PUT" : "POST";

        let requestPayload = {
          portletModelData: JSON.stringify(modelToSend, _undefinedReplacer),
          portletModelURL: modelURL,
          portletModelHttpMethod: httpMethod,
          rootMoniker: this.filterMoniker,
          portletStore: JSON.stringify(App.CivicsStore[this.portletId], _undefinedReplacer)
        }

        filterCodeModel.set(requestPayload);
        filterCodeModel.save().done((response) => {
          // retPromise.resolve(response.get('documents'));
          retPromise.resolve(new IpsCollection(response['documents']));
        }).fail((response) => {
          retPromise.reject(response);
        });
        //this will do a post.

        return retPromise;
      }
    }


  /**
   * Transform undefined properties to an empty string.
   * @param {string} key - property key
   * @param {*} value - property value
   * @returns returns the original value of the property or an empty string if undefined.
   */
  let _undefinedReplacer = (key, value) => {
    return value === undefined ? "" : value;
  }

    /**
   * After load processing - the function invokes the rebuild of filter codes dropdown
   * and setting up previous data for property based filter codes.
   * @param {object} $input - target dropdown jquery input for the filter code
   * @param {object} filterCodesData - filter code collection
   * @param {*} currentData - current value of the condition field for filter code.
   */
    const _setupInputField = ($input, filterCodesData, currentData) => {
      if (filterCodesData !== undefined && filterCodesData.length > 0) {
        _rebuildDropDownOptions($input, filterCodesData);
        this.previousData = currentData;
      }
    }

    /**
   * Setting up event handlers after the first time we load the filter code.
   * @param {object} $input - target dropdown jquery input for the filter code
   */
    const _setPostRenderEvent = ($input) => {
      $.fn.reloadFilterCodes = () => {
        if (this.conditionFilterType.toLowerCase() === FILTER_PROPERTY_TYPE)
          loadFilterCodes($input);
        return this;
      }
      _attachInputEventHandlers($input);
    }
    //Function that attach on field focus event to the generic filter field.
    const _attachInputEventHandlers = ($input) => {
      $input.on("focus", _fieldFocus);
    }

    // Callback function for the on field focus event.
    const _fieldFocus = (e) => {
      loadFilterCodes($(e.target));
    }

    // Function that rebuilds the dropplist options
    const _rebuildDropDownOptions = ($input, filterCodesData) => {
      let $droppyList = Utils.civicsGetDroppyList($input);
      //w/o the empty code.
      let filteredListCodes = filterCodesData.models.filter(entry => entry.get('code') !== undefined && entry.get('code') !== null && entry.get('code') !== '');

      let rawListCodes = filterCodesData.models.filter(entry => entry.get('code') !== undefined && entry.get('code') !== null)


      let selectionToSet = false;
      let serverSelectionToSet = '';
      let elementArray = [];
      let codesAray = rawListCodes.map(x => x.get('code'));

      codesAray.sort((a, b) => a.localeCompare(b));

      this.prevDropdownSelectionValue = Utils.civicsDropdownValue($input);

      $.each(filteredListCodes, (index, item) => {
        if (item.get('code') === this.prevDropdownSelectionValue) {
          selectionToSet = this.prevDropdownSelectionValue;
          return false;
        }

        if (item.get('IsDefaultOption') === true) {
          serverSelectionToSet = item.get('code');
        }
      });

      selectionToSet = selectionToSet ? selectionToSet : serverSelectionToSet;

      //Add the empty Select option
      let defaultOption = {
        value: '',
        text: i18n.t('CIVICS.COMMON.SELECT')
      };

      elementArray.push(partialDropdownOption($.extend({}, defaultOption)));

      $.each(filteredListCodes, (index, data) => {

        let isSelected = data.get('code') === selectionToSet;
        let description = data.get('description') ? data.get('description') : i18n.t('CIVICS.COMMON.VALUE_NOT_CONFIG')

        let optionData = {
          value: data.get('code'),
          text: description,
          selected: isSelected
        };
        elementArray.push(partialDropdownOption($.extend({}, optionData)));
      });

      $input.trigger("rebuildDroppyList", [codesAray, $droppyList, elementArray, selectionToSet]);
    }

    return {
      render: _render
    }
  }


  return GenericFilterCodes;
});
